const GUEST_AUTH_ROUTES = ['/sign-in', '/forgot-password', '/unlock-account', '/activate-account', '/sign-out'];

const AUTH_SESSION_API_PATHS = [
    '/api/authentication/sign-in',
    '/api/authentication/sign-out',
    '/api/authentication/refresh-token',
];

export function isGuestAuthRoute(url: string): boolean {
    const path = `${url || ''}`.split('?')[0];
    return GUEST_AUTH_ROUTES.some((route) => path === route || path.startsWith(`${route}/`));
}

export function isAuthSessionApiUrl(url: string): boolean {
    return AUTH_SESSION_API_PATHS.some((path) => `${url || ''}`.includes(path));
}

export function resolveSafeRedirectUrl(rawUrl?: string | null, fallback = '/dashboard'): string {
    let candidate = `${rawUrl || ''}`.trim();
    if (!candidate) {
        return fallback;
    }

    for (let index = 0; index < 8; index++) {
        const path = candidate.split('?')[0];
        if (!isGuestAuthRoute(path) && path !== '/sign-out') {
            return candidate;
        }

        try {
            const parsed = new URL(candidate, 'https://local.test');
            const nested = parsed.searchParams.get('redirectURL');
            if (!nested) {
                return fallback;
            }
            candidate = decodeURIComponent(nested);
        } catch {
            return fallback;
        }
    }

    return fallback;
}
